import { createReducer } from 'lib/redux/reducerUtils'
import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from 'actions/actionConstants'
import { businessTravellerApiFailureActions, businessTravellerApiRequestActions, businessTravellerApiSuccessActions } from './businessTravellerApiActionReducers'
import { ValueOf } from 'type-fest'

const BUSINESS_TRAVELLER_INITIAL_STATE: BusinessTraveller.State = {
  currentBusinessAccount: undefined,
  offersCredits: {},
  businessBudgets: {},
  businessFlightPolicy: { status: 'pending', policy: undefined },
  businessFlightBudgets: {},
  budgets: {},
  flightSearchBudget: {},
  onboarding: undefined,
  employees: { status: 'pending', all: {} },
  selectedTravellerEmployeeIds: [],
}

export enum BUSINESS_TRAVELLER_ACTIONS {
  RESET = 'BUSINESS_TRAVELLER_RESET',
  SET_BUSINESS_TRAVELLER = 'BUSINESS_TRAVELLER_SET_BUSINESS_TRAVELLER',
}

type Actions = Utils.FullActionMap<{
  [BUSINESS_TRAVELLER_ACTIONS.RESET]: {},
  [BUSINESS_TRAVELLER_ACTIONS.SET_BUSINESS_TRAVELLER]: { employeeIds?: string[] },
}>

const businessTravellerReducer = createReducer<BusinessTraveller.State, ValueOf<Actions>>(
  BUSINESS_TRAVELLER_INITIAL_STATE,
  {
    [API_CALL_REQUEST]: (state, action) => businessTravellerApiRequestActions(action.api)(state, action),
    [API_CALL_SUCCESS]: (state, action) => businessTravellerApiSuccessActions(action.api)(state, action),
    [API_CALL_FAILURE]: (state, action) => businessTravellerApiFailureActions(action.api)(state, action),
    [BUSINESS_TRAVELLER_ACTIONS.SET_BUSINESS_TRAVELLER]: (state, action) => {
      return {
        selectedTravellerEmployeeIds: action.employeeIds,
      }
    },
    [BUSINESS_TRAVELLER_ACTIONS.RESET]: () => ({ ...BUSINESS_TRAVELLER_INITIAL_STATE }),
  },
)

export default businessTravellerReducer
